import React from 'react';
import { Navbar, Container, Nav, NavDropdown } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

const Header = ({ onSignOut }) => {
  const loggedInUserDetails = JSON.parse(localStorage.getItem('loggedInUserDetails'));
  const username = loggedInUserDetails?.Name || ""
  return (
    <Navbar bg="light" expand="lg" style={{ padding: 0, width: '100%' }}>
      <Container fluid style={{ margin: 0 }}>
        <Navbar.Brand href="/" className='page-label'>Git Metrics</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={NavLink} to="/">Home</Nav.Link>
            <NavDropdown title="Reports" id="basic-nav-dropdown">
              <NavDropdown.Item as={NavLink} to="/commit-history">Commit History</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/pr-history">PR History</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/developer-reports">Developer LOC Monthly Reports</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/commits-reports">Commits Monthly Reports</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/pr-reports">PRs Monthly Reports</NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/weekly-exception-report">Weekly Exception Reports</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={NavLink} to="/power-user-reports">Power Users Reports</NavDropdown.Item>
            </NavDropdown>
            <Nav.Link as={NavLink} to="/configuration">Configuration</Nav.Link>
            <Nav.Link as={NavLink} to="/about">About</Nav.Link>
          </Nav>

          <div className="d-flex align-items-center ms-auto">
            <span style={{ marginRight: '1rem', fontSize: '0.95rem', color: '#333' }}>
              Welcome, <strong>{username}</strong>
            </span>
            <button
              onClick={onSignOut}
              style={{
                padding: '6px 12px',
                fontSize: '0.9rem',
                backgroundColor: '#0078d4',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              Sign Out
            </button>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

Header.propTypes = {
  onSignOut: PropTypes.func,
};

export default Header;
